import React from 'react';
import { Tab, Tabs, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import Info from './Info';
import PromoteStudents from './PromoteStudents';
import './commission.css';

const TabbedInterface = ({ mentorList, commission, setCommission, searchMentors }) => {
  return (
    <Col xs={12} lg={7} className='mb-4'>
      <div className='commission-tabs-wrapper'>
        <Tabs
          defaultActiveKey='info'
          id='commission-tabs'
          className='commission-tabs mb-3'
        >
          <Tab
            eventKey='info'
            title={
              <span className='commission-tab-title'>
                <FontAwesomeIcon
                  icon={faSlidersH}
                  className='commission-tab-icon'
                />
                <span>Información General</span>
              </span>
            }
          >
            <Info
              mentorList={mentorList}
              commission={commission}
              setCommission={setCommission}
              searchMentors={searchMentors}
            />
          </Tab>
          <Tab
            eventKey='other'
            title={
              <span className='commission-tab-title'>
                <FontAwesomeIcon
                  icon={faExchangeAlt}
                  className='commission-tab-icon'
                />
                <span>Migrar de Classroom</span>
              </span>
            }
          >
            <div className='commission-card p-4'>
              <PromoteStudents commission={commission} />
            </div>
          </Tab>
        </Tabs>
      </div>
    </Col>
  );
};

export default TabbedInterface;